<template>
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M7 2V22M17 2V22M22 7H2M22 17H2" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
    </svg>
</template>